import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { PriceModule } from '../price';
import { BulkPaymentPriceComponent } from './bulk-payment-price.component';

@NgModule({
  declarations: [ BulkPaymentPriceComponent ],
  imports: [
    CommonModule,
    FlexLayoutModule,
    MatIconModule,
    TranslateModule.forChild(),
    PriceModule
  ],
  exports: [ BulkPaymentPriceComponent ]
})
export class BulkPaymentPriceModule {
}
